export const LOAD_GEO_API = "LOAD_GEO_API"
export const LOAD_GEO_API_SUCCESS = "LOAD_GEO_API_SUCCESS"
export const LOAD_GEO_API_ERROR = "LOAD_GEO_API_ERROR"
export const LOAD_GEO_API_RESET = "LOAD_GEO_API_RESET"